module.exports = __webpack_public_path__ + "static/media/scholarship.2bacf444.jpeg";